import { isSet } from '../utils/isSet';

class PageNavigation {
    constructor (domNode) {
        this.domNode = domNode;
        this.links = Array.from(this.domNode.querySelectorAll('.page-navigation__link'));

        this.targetSections = [];
        this.init();
    }

    init(){
        this.registerSectionTitles();
        this.registerSectionIntersection();
    }

    registerSectionTitles(){
        this.links.forEach(link => {
            const index = link.dataset.index;
            if(!isSet(index)){
                link.parentElement.remove();
                return;
            } 

            const targetSection = document.querySelector('section[data-section-index="' + index + '"]');
            if(!isSet(targetSection)){
                link.parentElement.remove();
                return;
            } 

            const targetSectionLabel = targetSection.dataset.sectionLabel;
            if(!isSet(targetSectionLabel)){
                link.parentElement.remove();
                return;
            }

            const targetSectionId = targetSection.id;
            if(!isSet(targetSectionId)){
                link.parentElement.remove();
                return;
            }

            link.textContent = targetSectionLabel;

            link.href = '#' + targetSectionId;

            link.dataset.sectionId = targetSection.id;

            this.targetSections.push(targetSection);
        });
    }

    registerSectionIntersection(){
        const observableElms = this.targetSections;
        const links = this.links;
    
        let intersectionObserver = new IntersectionObserver(
            (entries) =>{
                entries.forEach((entry) => {
                    entry.target.classList.toggle("is-intersecting",entry.isIntersecting);
                    const match = links.find((link) => entry.target.id === link.dataset.sectionId);

                    if(isSet(match)) match.classList.toggle("is-intersecting",entry.isIntersecting);
                });
            },
            {threshold: 0.15}
        );
        observableElms.forEach(function(section) {
            intersectionObserver.observe(section);
        });
    }
}

exports.PageNavigation = PageNavigation